import { MENU_ONE_CLOSE , MENU_ONE_OPEN , MENU_TWO_CLOSE , MENU_TWO_OPEN } from "./actionTypes"

export const menuOneOpen = (val) => ({ type : MENU_ONE_OPEN , val:val })

export const menuOneClose = () => ({ type : MENU_ONE_CLOSE })

export const menuTwoOpen = (val) => ({ type : MENU_TWO_OPEN , val:val})

export const menuTwoClose = () => ({ type : MENU_TWO_CLOSE })
